import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchMyWorkshops } from '../../../api/me-workshops';
import type { WorkshopLifecycle } from '../../../api/workshops';
import type { WorkshopChip } from '../primitives';

import { toWorkshopChip } from './teacherApi';

const STALE_30S = 30_000;

/** One of the teacher's own workshops: a calendar chip that also knows
 *  whether it can take check-ins. */
export interface MyWorkshop extends WorkshopChip {
  lifecycle: WorkshopLifecycle;
  checkInOpensAt: string;
}

/** The signed-in teacher's own workshops starting on the given dates
 *  (`YYYY-MM-DD`, both ends included). Waits until both ends are known. */
export function useMyWorkshops(fromDate?: string, toDate?: string) {
  return useQuery({
    queryKey: ['me', 'workshops', fromDate, toDate],
    queryFn: async (): Promise<MyWorkshop[]> =>
      (await fetchMyWorkshops(fromDate as string, toDate as string)).map((w) => ({
        ...toWorkshopChip(w),
        lifecycle: w.lifecycle,
        checkInOpensAt: w.checkInOpensAt,
      })),
    // See the Overview's `useRegionWorkshops`: a new range keeps the last
    // answer on screen rather than an empty calendar.
    placeholderData: keepPreviousData,
    staleTime: STALE_30S,
    enabled: Boolean(fromDate && toDate),
  });
}
